(function () {
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
const $2844b45deb73c289$var$basePath = "https://europe-central2-sphere-385104.cloudfunctions.net";
const $2844b45deb73c289$export$5b11dd51e26ada16 = `${$2844b45deb73c289$var$basePath}/login`;
const $2844b45deb73c289$export$c23c9806c2c0bf65 = `${$2844b45deb73c289$var$basePath}/getRecordsFromCdn` // info + tracks
;
const $2844b45deb73c289$export$4d887f518cc2d6e5 = `${$2844b45deb73c289$var$basePath}/updateRecordStatus`;
const $2844b45deb73c289$export$7968387652a9ccb5 = `${$2844b45deb73c289$var$basePath}/updateSongStats`;


const $923d0d426c4966e8$export$742a865efb1d415d = document.body.classList.contains("ru") ? "ru" : "en";
function $923d0d426c4966e8$export$61fc7d43ac8f84b0(func, timeout) {
    let timer;
    return (...args)=>{
        clearTimeout(timer);
        timer = setTimeout(()=>{
            func.apply(this, args);
        }, timeout);
    };
}
const $923d0d426c4966e8$export$61d4212795f516b4 = async (baseId, tableId)=>{
    const queryParams = {
        baseId: baseId,
        tableId: tableId
    };
    const searchParams = new URLSearchParams(queryParams);
    const urlToFetchRecords = `${(0, $2844b45deb73c289$export$c23c9806c2c0bf65)}?${searchParams}`;
    try {
        const response = await fetch(urlToFetchRecords);
        const playlist = await response.json();
        console.log("pl", playlist);
        return playlist;
    } catch (error) {
        console.warn(`there was a network error, when loading ${tableId} playlist`);
        // console.warn(`"${playlistName}" not found`)
        console.log(error);
    }
};
function $923d0d426c4966e8$export$448332262467e042(array) {
    // THIS function only shuffles array
    for(let i = array.length - 1; i > 0; i--){
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [
            array[j],
            array[i]
        ]; // Swap elements
    }
    // Shuffles array which commes as an argument
    return array;
}
function $923d0d426c4966e8$export$a477072d5b4aa0b(array) {
    const chunks = [];
    const length = array.length;
    console.log("initial array of tracks", array);
    for(let i = 0; i < length; i += 10){
        const chunk = array.slice(i, i + 10);
        // const randomized = shuffle(chunk)
        chunks.push($923d0d426c4966e8$export$448332262467e042(chunk));
    }
    // [[1,2,3],[4,5,6]] -> [1,2,3,4,5,6]
    //
    const shuffledTracks = chunks.flat();
    const secondTracks = [];
    for(let i = 1; i < length; i += 2)secondTracks.push(shuffledTracks[i]);
    const randomizedSecondTracks = $923d0d426c4966e8$export$448332262467e042(secondTracks);
    let counter = 0;
    for(let i = 1; i < length; i += 2){
        const randomizedTrack = randomizedSecondTracks[counter];
        counter++;
        shuffledTracks[i] = randomizedTrack;
    }
    console.log(`shuffledTracks (at first shuffled by 10, then also randomized each 2nd)`, shuffledTracks);
    return shuffledTracks;
}
const $923d0d426c4966e8$export$3559f76af9e67f62 = async (data)=>{
    try {
        const response = await fetch((0, $2844b45deb73c289$export$4d887f518cc2d6e5), {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(data)
        });
        return response.json();
    } catch (error) {
        console.log(error);
    }
};
const $923d0d426c4966e8$export$fb42892a594639e4 = async (data)=>{
    try {
        const response = await fetch((0, $2844b45deb73c289$export$7968387652a9ccb5), {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(data)
        });
        return response.text();
    } catch (error) {
        console.log(error);
    }
};
const $923d0d426c4966e8$export$ac4644619b26e57d = (playlistsInfo)=>{
    const currentSelectedPlaylistButton = document.querySelector(".playlist--selected");
    const currentPlaylistName = currentSelectedPlaylistButton.dataset.playlistName;
    const currentPlaylist = playlistsInfo.find((playlist)=>playlist.playlistName === currentPlaylistName);
    const currentPlaylistTableId = currentPlaylist.tableId;
    // debugger
    return currentPlaylistTableId;
} // old from here and below
 // sendLikeDislike & updateSongStats
 // usage example
 // (async () => {
 //   const dataExample = {
 //     baseId: 'example base id',
 //     // tableId may contain actual id or just a playlistname
 //     // → tableId: 'tblhkaJOe'
 //     // → tableId: 'Second test playlist'
 //     tableId: 'example playlist name',
 //     recordId: 'example id',
 //     newStatus: 'Like' // or 'Dislike'
 //   }
 //
 //   const data = {
 //     baseId: 'fake_app62dBMf9YymV',
 //     tableId: 'Second test playlist',
 //     recordId: 'recJNCFEtgQ0ESpyg',
 //   }
 //
 //   const response = await updateSongStats(data)
 //   console.log('j', response)
 // })()
 // export function shuffle(array) {
 //   var currentIndex = array.length, temporaryValue, randomIndex;
 //
 //   // While there remain elements to shuffle...
 //   while (0 !== currentIndex) {
 //
 //     // Pick a remaining element...
 //     randomIndex = Math.floor(Math.random() * currentIndex);
 //     currentIndex -= 1;
 //
 //     // And swap it with the current element.
 //     temporaryValue = array[currentIndex];
 //     array[currentIndex] = array[randomIndex];
 //     array[randomIndex] = temporaryValue;
 //   }
 //
 //   return array;
 // }
 // export function animateHowlerPlayButton() {
 //   document.querySelector("#howler-play").style.transition = 'visibility, opacity 0.25s ease-in'
 //   document.querySelector("#howler-play").style.visibility = 'visible'
 //   document.querySelector("#howler-play").style.opacity = 1
 // }
 //
 // export function seekPlayingSongToAnEnd(secondsBeforeEnd = 10) {
 //   // secondsBeforeEnd is an overridable default value
 //   if (!sound1 && !sound2) {
 //     console.warn('для перемотки трэка нужно сначала включить плеер')
 //     return
 //   }
 //   if ((sound1 && !sound1.playing()) && (sound2 && !sound2.playing())) {
 //     console.warn('перемотка работает только во время воспроизведения трэка')
 //     return
 //   }
 //   if (sound1 && sound1.playing()) {
 //     sound1.seek(sound1.duration() - secondsBeforeEnd)
 //     console.log(`sound1 перемотана, до следующей песни осталось ${secondsBeforeEnd} секунд`)
 //   }
 //   if (sound2 && sound2.playing()) {
 //     sound2.seek(sound2.duration() - secondsBeforeEnd)
 //     console.log(`sound2 перемотана, до следующей песни осталось ${secondsBeforeEnd} секунд`)
 //   }
 // }
 //
 // export function addLikeDislikeClickHandlers() {
 //   $("#submitLike").on("click", function (e) {
 //
 //     if (sound1 == undefined || sound2 === undefined) {
 //       console.error('Error! Start player to enable likes');
 //       return;
 //     }
 //
 //     scheduleLikeOnSongEnd()
 //   });
 //
 //   $("#submitDislike").on("click", function (e) {
 //
 //     if (sound1 == undefined || sound2 === undefined) {
 //       console.error('Error! Start player to enable dislikes');
 //       return;
 //     }
 //
 //     scheduleDislikeOnSongEnd()
 //   });
 // }
 // console.log('helpers')
 // ================
 // function insertingLikeDislikeFormDataFunctionExample() {
 //
 //   if (playingList == list1) {
 //     $("input[name=playlistname]").val("Day list");
 //   } else {
 //     $("input[name=playlistname]").val("Weekend playlist");
 //   }
 //
 //   if (sound1.playing() && !sound2.playing()) {
 //     //console.log(sound1._src.split("musicLibrary/")[1]);
 //     var song1name = sound1._src.split("https://570427.selcdn.ru/Sphere/musiclibrary/")[1];
 //     $("input[name=songname]").val(song1name);
 //   } else if (!sound1.playing() && sound2.playing()) {
 //     //console.log(sound2._src.split("musicLibrary/")[1]);
 //     var song2name = sound2._src.split("https://570427.selcdn.ru/Sphere/musiclibrary/")[1];
 //     $("input[name=songname]").val(song2name);
 //   } else {
 //     $("input[name=songname]").val("?error?");
 //   }
 // }
 //
 // export let likeDislikeState = {
 //   shouldLike: false,
 //   shouldDislike: false,
 //   requestData: {}
 // }
 //
 // export function scheduleLikeOnSongEnd() {
 //   likeDislikeState = {
 //     shouldLike: true,
 //     shouldDislike: false,
 //   }
 //
 //   likeDislikeState.requestData = getRequestData()
 // }
 //
 // export function scheduleDislikeOnSongEnd() {
 //   likeDislikeState = {
 //     shouldLike: false,
 //     shouldDislike: true,
 //   }
 //
 //   likeDislikeState.requestData = getRequestData()
 // }
 //
 // export function resetLikeDislikeState() {
 //   likeDislikeState = {
 //     shouldLike: false,
 //     shouldDislike: false,
 //     requestData: {}
 //   }
 // }
 //
 // export function getRequestData() {
 //   insertingLikeDislikeFormData();
 //
 //   let formData;
 //   if (likeDislikeState.shouldLike === true) formData = $formLike.serializeObject();
 //   if (likeDislikeState.shouldDislike === true) formData = $formDislike.serializeObject();
 //   // reset like dislike app state
 //
 //   const requestData = {
 //     ...formData,
 //     login: formData.place,
 //     password: localStorage.getItem('password'),
 //     projectFolderName, // should be defined in a playRules script
 //     placeFolderName, // should be defined in a playRules script
 //     playlistFileName: playlists[formData.playlistname], // "playlists" should be defined in a playRules script
 //     'client timestamp': new Date().toLocaleString("ru-RU")
 //   }
 //
 //   return requestData
 // }
 //
 // export function sendLikeDislikeIfScheduled() {
 //   if (likeDislikeState.shouldLike || likeDislikeState.shouldDislike) {
 //     sendLikeDislikeToServer()
 //   }
 // }
 //
 // export function sendLikeDislikeToServer() {
 //
 //   const requestData = likeDislikeState.requestData
 //   resetLikeDislikeState()
 //
 //   if (playingList && requestData.value === 'dislike') {
 //     const dislikedSongName = requestData.songname
 //
 //     playingList = playingList.filter(songURL => {
 //       // extract songName from song url (get part of the url, that goes after last slash)
 //       const songName = songURL.replace(/.*[/]/ig, '');
 //
 //       return songName !== dislikedSongName
 //     })
 //   }
 //
 //   var jqxhr = $.ajax({
 //     url: serverlessFunctionUrl,
 //     method: "POST",
 //     contentType: 'text/plain',
 //     // data: JSON.stringify($formLike.serializeObject()),
 //     data: JSON.stringify(requestData),
 //     success: console.log("value sended")
 //   })
 //     .done(function (res) {
 //       if (res.result === 'success') console.log(res.message);
 //       if (res.result === 'error') console.error(res.message);
 //     });
 // }
;



let $72239ddbc700e165$var$username;
const $72239ddbc700e165$var$loginScreenAnimationDuration = 250;
const $72239ddbc700e165$var$loginPopupAnimationDuration = $72239ddbc700e165$var$loginScreenAnimationDuration;
const $72239ddbc700e165$var$loadingPlaceholderAnimationDuration = $72239ddbc700e165$var$loginScreenAnimationDuration;
const $72239ddbc700e165$var$loginScreen = document.querySelector("#login-screen");
const $72239ddbc700e165$var$loginForm = document.querySelector("#login-form");
const $72239ddbc700e165$var$removeFullpagePopup = ()=>{
    // animate popup dissapearing
    $72239ddbc700e165$var$loginScreen.style.transitionDuration = `${$72239ddbc700e165$var$loginScreenAnimationDuration}ms`;
    $72239ddbc700e165$var$loginScreen.style.transitionTimingFunction = "ease-out";
    $72239ddbc700e165$var$loginScreen.style.visibility = "hidden";
    $72239ddbc700e165$var$loginScreen.style.opacity = 0;
    setTimeout(()=>{
        // remove login screen from dom after animation ends
        $72239ddbc700e165$var$loginScreen.parentNode.removeChild($72239ddbc700e165$var$loginScreen);
    }, $72239ddbc700e165$var$loginScreenAnimationDuration);
};
const $72239ddbc700e165$var$showLoginPopup = ()=>{
    const loginPopup = document.querySelector("#login-popup");
    loginPopup.style.transitionDuration = `${$72239ddbc700e165$var$loginPopupAnimationDuration}ms`;
    loginPopup.style.transitionTimingFunction = "ease-in";
    loginPopup.style.visibility = "visible";
    loginPopup.style.opacity = 1;
};
const $72239ddbc700e165$var$logIn = async (username, password)=>{
    // const requestUrl = 'http://localhost:8095/'
    const requestUrl = (0, $2844b45deb73c289$export$5b11dd51e26ada16);
    return fetch(requestUrl, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            login: username,
            password: password
        })
    });
};
// login form error message handling
const $72239ddbc700e165$var$loginFormErrorMessage = $72239ddbc700e165$var$loginForm.querySelector("#error-message");
const $72239ddbc700e165$var$loginFormErrorMessageAnimationTransitionDurationMs = 250;
const $72239ddbc700e165$var$timeErrorMessageIsVisibleMs = 5000;
const $72239ddbc700e165$var$showErrorMessage = ()=>{
    $72239ddbc700e165$var$loginFormErrorMessage.style.transitionDuration = `${$72239ddbc700e165$var$loginFormErrorMessageAnimationTransitionDurationMs}ms`;
    $72239ddbc700e165$var$loginFormErrorMessage.style.visibility = "visible";
    $72239ddbc700e165$var$loginFormErrorMessage.style.opacity = "1";
    $72239ddbc700e165$var$setLoginFormErrorMessageHidingTimer();
};
const $72239ddbc700e165$var$setLoginFormErrorMessageHidingTimer = (0, $923d0d426c4966e8$export$61fc7d43ac8f84b0)(()=>{
    // hide login form error message after some delay
    $72239ddbc700e165$var$loginFormErrorMessage.style.transitionDuration = `${$72239ddbc700e165$var$loginFormErrorMessageAnimationTransitionDurationMs}ms`;
    $72239ddbc700e165$var$loginFormErrorMessage.style.visibility = "hidden";
    $72239ddbc700e165$var$loginFormErrorMessage.style.opacity = "0";
}, $72239ddbc700e165$var$timeErrorMessageIsVisibleMs);
const $72239ddbc700e165$export$da4fc2bf424da4ca = async (callback)=>{
    // it is used to set a background to body
    // otherwise it will be a flash of white on initial page load
    // this should be fixed by css, but for now it's easier to do this instead
    document.body.classList.add("html-parsed");
    // check url if it has login and password in it
    const searchParams = new URL(window.location.href).searchParams;
    const trial = searchParams.get("tariff") === "trial";
    if (trial) {
        localStorage.setItem("login", searchParams.get("login"));
        localStorage.setItem("password", searchParams.get("password"));
    }
    Promise.all([
        new Promise((resolve)=>{
            window.addEventListener("requiredDelayTimeIsUp", (_)=>resolve(), {
                once: true
            });
        }),
        new Promise((resolve, reject)=>{
            window.addEventListener("loggedInFromBrowserMemory", (_)=>resolve(), {
                once: true
            });
            window.addEventListener("loggedInFromInput", (_)=>resolve(), {
                once: true
            });
        })
    ]).then(()=>{
        if (trial || $72239ddbc700e165$var$username === "Instream") // hide like/dislike buttons
        document.querySelector("#like-dislike-form").style.visibility = "hidden";
        $72239ddbc700e165$var$removeFullpagePopup();
    });
    const requiredLoadingMinDelayMilliseconds = 250;
    setTimeout(()=>{
        window.dispatchEvent(new CustomEvent("requiredDelayTimeIsUp"));
    }, requiredLoadingMinDelayMilliseconds);
    $72239ddbc700e165$var$username = localStorage.getItem("login");
    const password = localStorage.getItem("password");
    if ($72239ddbc700e165$var$username && password) {
        const loginResponse = await $72239ddbc700e165$var$logIn($72239ddbc700e165$var$username, password);
        if (loginResponse.ok) {
            const response = await loginResponse.json();
            const { baseId: baseId, placeName: placeName } = response;
            document.querySelector("#place-name").innerHTML = placeName;
            callback(baseId);
            window.dispatchEvent(new CustomEvent("loggedInFromBrowserMemory"));
            return;
        }
    }
    // user is not logged in
    // animate login popup appearing
    (()=>{
        const loadingPlaceholder = document.querySelector("#loading-placeholder");
        loadingPlaceholder.style.visibility = "hidden";
        loadingPlaceholder.style.opacity = 0;
        loadingPlaceholder.style.transitionDuration = `${$72239ddbc700e165$var$loadingPlaceholderAnimationDuration}ms`;
        // loading text dissapears -> show login popup
        const delay = 250 // add delay, so popup will animate not immediately, but after some amount of milliseconds
        ;
        setTimeout(()=>$72239ddbc700e165$var$showLoginPopup(), $72239ddbc700e165$var$loadingPlaceholderAnimationDuration + delay);
    })();
    const usernameInput = $72239ddbc700e165$var$loginForm.querySelector(`.js-login-input.${(0, $923d0d426c4966e8$export$742a865efb1d415d)}`);
    const passwordInput = $72239ddbc700e165$var$loginForm.querySelector(`.js-password-input.${(0, $923d0d426c4966e8$export$742a865efb1d415d)}`);
    $72239ddbc700e165$var$loginForm.onsubmit = async (e)=>{
        e.preventDefault();
        console.log("form submitted");
        $72239ddbc700e165$var$username = usernameInput.value;
        const password = passwordInput.value;
        if (password.trim().length === 0) {
            // empty password
            console.warn("empty password");
            return;
        }
        const loginResponse = await $72239ddbc700e165$var$logIn($72239ddbc700e165$var$username, password);
        if (loginResponse.ok) {
            const response = await loginResponse.json();
            const { baseId: baseId, placeName: placeName } = response;
            document.querySelector("#place-name").innerHTML = placeName;
            callback(baseId);
            localStorage.setItem("login", $72239ddbc700e165$var$username);
            localStorage.setItem("password", password);
            window.dispatchEvent(new CustomEvent("loggedInFromInput"));
            return;
        } else $72239ddbc700e165$var$showErrorMessage();
    };
};



function $1d4928dd02c4c5ce$export$1e71eb4bef00f6b0(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}


var $f7613f0594d90ee8$exports = {};
(function(global, factory) {
    $f7613f0594d90ee8$exports = factory();
})($f7613f0594d90ee8$exports, function() {
    "use strict";
    var fetchRetry = function(fetch, defaults) {
        defaults = defaults || {};
        if (typeof fetch !== "function") throw new ArgumentError("fetch must be a function");
        if (typeof defaults !== "object") throw new ArgumentError("defaults must be an object");
        if (defaults.retries !== undefined && !isPositiveInteger(defaults.retries)) throw new ArgumentError("retries must be a positive integer");
        if (defaults.retryDelay !== undefined && !isPositiveInteger(defaults.retryDelay) && typeof defaults.retryDelay !== "function") throw new ArgumentError("retryDelay must be a positive integer or a function returning a positive integer");
        if (defaults.retryOn !== undefined && !Array.isArray(defaults.retryOn) && typeof defaults.retryOn !== "function") throw new ArgumentError("retryOn property expects an array or function");
        var baseDefaults = {
            retries: 3,
            retryDelay: 1000,
            retryOn: []
        };
        defaults = Object.assign(baseDefaults, defaults);
        return function fetchRetry(input, init) {
            var retries = defaults.retries;
            var retryDelay = defaults.retryDelay;
            var retryOn = defaults.retryOn;
            if (init && init.retries !== undefined) {
                if (isPositiveInteger(init.retries)) retries = init.retries;
                else throw new ArgumentError("retries must be a positive integer");
            }
            if (init && init.retryDelay !== undefined) {
                if (isPositiveInteger(init.retryDelay) || typeof init.retryDelay === "function") retryDelay = init.retryDelay;
                else throw new ArgumentError("retryDelay must be a positive integer or a function returning a positive integer");
            }
            if (init && init.retryOn) {
                if (Array.isArray(init.retryOn) || typeof init.retryOn === "function") retryOn = init.retryOn;
                else throw new ArgumentError("retryOn property expects an array or function");
            }
            // eslint-disable-next-line no-undef
            return new Promise(function(resolve, reject) {
                var wrappedFetch = function(attempt) {
                    // As of node 18, this is no longer needed since node comes with native support for fetch:
                    /* istanbul ignore next */ var _input = typeof Request !== "undefined" && input instanceof Request ? input.clone() : input;
                    fetch(_input, init).then(function(response) {
                        if (Array.isArray(retryOn) && retryOn.indexOf(response.status) === -1) resolve(response);
                        else if (typeof retryOn === "function") try {
                            // eslint-disable-next-line no-undef
                            return Promise.resolve(retryOn(attempt, null, response)).then(function(retryOnResponse) {
                                if (retryOnResponse) retry(attempt, null, response);
                                else resolve(response);
                            }).catch(reject);
                        } catch (error) {
                            reject(error);
                        }
                        else if (attempt < retries) retry(attempt, null, response);
                        else resolve(response);
                    }).catch(function(error) {
                        if (typeof retryOn === "function") try {
                            // eslint-disable-next-line no-undef
                            Promise.resolve(retryOn(attempt, error, null)).then(function(retryOnResponse) {
                                if (retryOnResponse) retry(attempt, error, null);
                                else reject(error);
                            }).catch(function(error) {
                                reject(error);
                            });
                        } catch (error) {
                            reject(error);
                        }
                        else if (attempt < retries) retry(attempt, error, null);
                        else reject(error);
                    });
                };
                function retry(attempt, error, response) {
                    var delay = typeof retryDelay === "function" ? retryDelay(attempt, error, response) : retryDelay;
                    setTimeout(function() {
                        wrappedFetch(++attempt);
                    }, delay);
                }
                wrappedFetch(0);
            });
        };
    };
    function isPositiveInteger(value) {
        return Number.isInteger(value) && value >= 0;
    }
    function ArgumentError(message) {
        this.name = "ArgumentError";
        this.message = message;
    }
    return fetchRetry;
});



const $d3b96eb1e0e45c37$var$fetchWithRetry = (0, (/*@__PURE__*/$parcel$interopDefault($f7613f0594d90ee8$exports)))(fetch);
let $d3b96eb1e0e45c37$var$likeDislikeStatus = {
    scheduled: false,
    newStatus: null
};
const $d3b96eb1e0e45c37$var$likeButton = document.querySelector("#like-button");
const $d3b96eb1e0e45c37$var$dislikeButton = document.querySelector("#dislike-button");
// parce an object parameter and get its newStatus key
const $d3b96eb1e0e45c37$var$scheduleLikeDislike = ({ newStatus: newStatus })=>{
    // make sure first letter is capitalized
    const firstLetter = newStatus[0].toUpperCase();
    const status = firstLetter + newStatus.toLowerCase().slice(1);
    if (status === "Like") $d3b96eb1e0e45c37$var$likeButton.classList.add("active");
    if (status === "Dislike") $d3b96eb1e0e45c37$var$dislikeButton.classList.add("active");
    $d3b96eb1e0e45c37$var$likeDislikeStatus = {
        scheduled: true,
        newStatus: status
    };
};
const $d3b96eb1e0e45c37$var$resetLikeDislikeScheduledValues = ()=>{
    // clean up
    $d3b96eb1e0e45c37$var$likeButton.classList.remove("active");
    $d3b96eb1e0e45c37$var$dislikeButton.classList.remove("active");
    $d3b96eb1e0e45c37$var$likeDislikeStatus = {
        scheduled: false,
        newStatus: null
    };
};
let $d3b96eb1e0e45c37$var$skipped = false;
let $d3b96eb1e0e45c37$var$playlistShouldChange = false;
let $d3b96eb1e0e45c37$var$globalRepeatId = null;
const $d3b96eb1e0e45c37$var$resetRepeatId = ()=>$d3b96eb1e0e45c37$var$globalRepeatId = null;
// ...
// let nextTrackBlobSize = null
let $d3b96eb1e0e45c37$var$nextTrackDownloadSpeed = null;
let $d3b96eb1e0e45c37$var$nextTrackDownloadTime = null;
class $d3b96eb1e0e45c37$export$2616165974278734 {
    async initializePlayer(availablePlaylists, baseId) {
        this.availablePlaylists = availablePlaylists;
        this.baseId = baseId;
        // Запрашиваем первый плейлист
        const firstPlaylist = availablePlaylists[0];
        // обновляем все данные о плейлисте
        await this.setPlaylistData({
            newPlaylist: firstPlaylist
        });
        try {
            await this.initializeFirstTwoTracksOfAPlaylist({
                firstTrackLoaded: ()=>{
                    this.initializePlayerHTMLControls();
                    document.body.classList.add("first-track-loaded");
                }
            });
        } catch (error) {
            // console.log('no tracks')
            // this.initializePlayerHTMLControls()
            console.error(`can't first two tracks`);
        }
        this.audioPlayer.addEventListener("ended", async (event)=>{
            // if playlist is changing, don't load next song of current playlist
            const playlistChange = $d3b96eb1e0e45c37$var$playlistShouldChange;
            // reset this global value
            $d3b96eb1e0e45c37$var$playlistShouldChange = false;
            document.getElementById("skip-button").disabled = true;
            const currentTrackUrl = this.currentTrackUrl;
            // console.log('currentDayPlaylist', this.currentDayPlaylist)
            // const currentTrackInitialData = this.currentPlaylistInitialData.find(trackData => trackData.signedUrl === currentTrackUrl)
            const currentTrackInitialData = this.currentPlaylistInitialData.find((trackData)=>trackData.fields["Full link"] === currentTrackUrl);
            // debugger;
            console.log("%ccurrentTrackIndex", "color: green", this.currentTrackIndex);
            console.log("currentTrackUrl", currentTrackUrl);
            // debugger
            const currentTrackId = currentTrackInitialData.id;
            // this object will be sent to server
            const data = {
                baseId: this.baseId,
                tableId: this.currentPlaylistTableId,
                recordId: currentTrackId,
                currentIndex: this.currentTrackIndex,
                // first and second tracks of a playlist are without speed and time calculations, so use empty strings instead...
                downloadingSpeed: $d3b96eb1e0e45c37$var$nextTrackDownloadSpeed ? $d3b96eb1e0e45c37$var$nextTrackDownloadSpeed.toFixed(1) : "",
                downloadingTime: $d3b96eb1e0e45c37$var$nextTrackDownloadTime ? $d3b96eb1e0e45c37$var$nextTrackDownloadTime.toFixed(1) : ""
            };
            // console.log('dataaaa', data)
            // debugger
            // reset this global variable
            $d3b96eb1e0e45c37$var$nextTrackDownloadSpeed = null;
            $d3b96eb1e0e45c37$var$nextTrackDownloadTime = null;
            let trackWasDeleted;
            if ($d3b96eb1e0e45c37$var$likeDislikeStatus.scheduled) {
                const newStatus = $d3b96eb1e0e45c37$var$likeDislikeStatus.newStatus;
                // set 'Like' or 'Dislike' that will be sent to server
                data.newStatus = newStatus;
                if (newStatus === "Dislike") {
                    // delete track from current playlist locally
                    this.tracks = this.tracks.filter((track)=>track !== currentTrackUrl);
                    trackWasDeleted = true;
                }
                setTimeout(()=>{
                    (0, $923d0d426c4966e8$export$3559f76af9e67f62)(data);
                }, 1200) // wait too overcome the 5 request per second limit
                ;
                $d3b96eb1e0e45c37$var$resetLikeDislikeScheduledValues();
            }
            const stats = data;
            stats.skipped = $d3b96eb1e0e45c37$var$skipped;
            stats.playlistName = this.currentPlaylistTableName;
            stats.timestamp = new Date().toLocaleString("ru-RU");
            let deviceUniqueId = localStorage.getItem("deviceUniqueId");
            if (!deviceUniqueId) {
                const time = new Date().getTime().toString();
                const id = time.slice(time.length - 5);
                localStorage.setItem("deviceUniqueId", id);
                deviceUniqueId = id;
            }
            stats.deviceUniqueId = deviceUniqueId;
            setTimeout(()=>{
                (0, $923d0d426c4966e8$export$fb42892a594639e4)(stats);
            // debugger
            // wait 3 seconds for hopefully pass airtable 5-requeste-at-once limit
            }, 3000);
            // reset skipped to initial value
            $d3b96eb1e0e45c37$var$skipped = false;
            console.log("audioPlayer ended");
            // if track is ended due to playlist change, don't load next track
            if (!playlistChange) await this.playAndLoadNextTrack({
                trackWasDeleted: trackWasDeleted
            });
        });
    }
    async setPlaylistData({ newPlaylist: newPlaylist }) {
        // show user friendly message
        document.querySelector("#current-playlist").innerHTML = "loading playlist...";
        this.currentPlaylistTableId = newPlaylist.tableId;
        this.currentPlaylistTableName = newPlaylist.playlistName;
        this.currentPlaylistInitialData = await (0, $923d0d426c4966e8$export$61d4212795f516b4)(this.baseId, this.currentPlaylistTableId);
        this.currentDayPlaylist = this.getCurrentDaySongsInPlaylist(this.currentPlaylistInitialData);
        const currentInterval = this.getCurrentInterval(this.currentDayPlaylist);
        this.currentIntervalData = this.getCurrentIntervalRelatedData(currentInterval);
        this.currentIntervalIndex = this.currentIntervalData.index;
        this.tracks = this.currentIntervalData.urls;
    }
    async initializeFirstTwoTracksOfAPlaylist({ firstTrackLoaded: firstTrackLoaded }) {
        document.querySelector("#current-playlist").innerHTML = "loading first track...";
        // reset
        this.currentTrackIndex = 0;
        this.nextTrackIndex = 1;
        // обходим ошибки с потерей контекста
        // const tracks = this.tracks
        // const nextTrackIndex = this.nextTrackIndex
        // const currentTrackIndex = this.currentTrackIndex
        const retryFirstTrack = ()=>{
            return this.loadTrack({
                tracks: this.tracks,
                trackIndex: this.currentTrackIndex
            }).catch(()=>{
                this.currentTrackIndex++;
                return retryFirstTrack();
            });
        };
        const retrySecondTrack = ()=>{
            return this.loadTrack({
                tracks: this.tracks,
                trackIndex: this.nextTrackIndex
            }).catch(()=>{
                this.nextTrackIndex++;
                return retrySecondTrack();
            });
        };
        retryFirstTrack().then((blobURL)=>{
            this.currentBlobURL = blobURL;
            this.currentTrackUrl = this.tracks[this.currentTrackIndex];
            this.audioPlayer.src = this.currentBlobURL;
            firstTrackLoaded();
            // show the name of a playlist to an user
            document.querySelector("#current-playlist").innerHTML = this.currentPlaylistTableName;
            console.log("first blob should be ready");
            // document.getElementById('skip-button').disabled = true
            return retrySecondTrack();
        }).then((blobURL)=>{
            this.nextBlobURL = blobURL;
            this.nextTrackUrl = this.tracks[this.nextTrackIndex];
            document.getElementById("skip-button").disabled = false;
            console.log("first two tracks of a playlist are initialized");
        }).catch((error)=>{
            console.error("Error setting the source for the audio player:", error);
        });
    }
    async playAndLoadNextTrack({ trackWasDeleted: trackWasDeleted }) {
        // debugger
        // If there is a next track
        // updateState(tracks[currentTrackIndex]);
        // console.log('tracks[currentTrackIndex] and signedURL is ' + this.tracks[this.currentTrackIndex])
        console.log("tracks[currentTrackIndex] and encodedURL is " + this.tracks[this.currentTrackIndex]);
        if (this.nextBlobURL) {
            // Revoke the blob URL of the track that just finished playing
            if (this.currentBlobURL) URL.revokeObjectURL(this.currentBlobURL);
            this.currentBlobURL = this.nextBlobURL;
            this.nextBlobURL = null;
            this.currentTrackUrl = this.nextTrackUrl;
            this.nextTrackUrl = null;
            this.audioPlayer.src = this.currentBlobURL;
            this.audioPlayer.play();
            // console.log(tracks[currentTrackIndex]);
            if (!trackWasDeleted) {
                // update indexes only if previous track wasnt' deleted
                // if track was deleted indexes remain the same
                this.currentTrackIndex = this.nextTrackIndex;
                this.nextTrackIndex++;
            }
            this.currentIntervalData = this.getCurrentInterval(this.currentDayPlaylist);
            const retry = ()=>{
                console.log("retry track index:", this.nextTrackIndex);
                // console.log('currentIIndex', this.currentIntervalIndex)
                if (this.currentIntervalIndex !== this.currentIntervalData.index) {
                    console.log("switched playlist interval");
                    console.log("current active interval is", this.currentIntervalData.time);
                    this.currentIntervalIndex = this.currentIntervalData.index;
                    // this.tracks = this.currentIntervalData.signedURLs;
                    this.tracks = this.currentIntervalData.encodedURLs;
                    this.nextTrackIndex = 0; // Start from the first track in the new interval
                // debugger
                } else if (this.nextTrackIndex >= this.tracks.length) // If we're beyond the end of the current tracks, loop back to the start
                this.nextTrackIndex = 0;
                // debugger
                // const tracks1 = this.tracks;
                // const trackIndex1 = this.nextTrackIndex;
                const downloadingTimeStart = new Date().getTime();
                let downLoadingTimeEnd;
                // const returnOnlyBlob = true
                return this.loadTrack({
                    tracks: this.tracks,
                    trackIndex: this.nextTrackIndex,
                    returnOnlyBlob: true
                }).then((blob)=>{
                    // on success, calculate how much time it took to download this track
                    downLoadingTimeEnd = new Date().getTime();
                    const downloadTimeInSeconds = (downLoadingTimeEnd - downloadingTimeStart) / 1000;
                    if (blob.size > 0) {
                        const blobSizeMb = blob.size / 1024 / 1024;
                        $d3b96eb1e0e45c37$var$nextTrackDownloadTime = downloadTimeInSeconds;
                        $d3b96eb1e0e45c37$var$nextTrackDownloadSpeed = blobSizeMb / downloadTimeInSeconds;
                        // debugger
                        console.log("Successfully fetched and have content in blob.");
                        return URL.createObjectURL(blob);
                    } else {
                        console.warn("Fetch was successful but blob is empty.");
                        return null;
                    }
                }).catch(()=>{
                    this.nextTrackIndex++;
                    return retry();
                });
            };
            retry().then((blobURL)=>{
                this.nextBlobURL = blobURL;
                this.nextTrackUrl = this.tracks[this.nextTrackIndex];
                // })
                // .then(() => {
                console.log("track loaded (with or without retry)");
                document.getElementById("skip-button").disabled = false;
            });
        }
    }
    initializePlayerHTMLControls() {
        const audioPlayer = this.audioPlayer;
        // player 'play' settings and event handlers
        const playButton = document.getElementById("play-button");
        const skipButton = document.getElementById("skip-button");
        // skipButton.addEventListener('click', () => this.playAndLoadNextTrack());
        skipButton.addEventListener("click", ()=>{
            // ставим флаг skipped в значение true
            $d3b96eb1e0e45c37$var$skipped = true;
            // здесь должна происходить перемотка трэка в конец,
            // чтобы потом автоматически сработала функция в onend у плеера,
            // там и отправляем всю статистику и данные
            // после отправки данных, возвращаем флаг в значение false (это уже в самом onend обработчике)
            this.audioPlayer.dispatchEvent(new Event("ended"));
        });
        playButton.addEventListener("click", togglePlayPause);
        const fadeInOutDuration = 800; // 2000ms = 2 seconds
        // set css custom variable for css animations
        playButton.style.setProperty("--animation-duration", fadeInOutDuration + "ms");
        // player 'play' controls
        function fadeAudioToPlaying() {
            let volume = 0.0;
            audioPlayer.volume = volume;
            audioPlayer.play();
            const fadeInterval = setInterval(function() {
                volume += 0.05; // increase by 0.05 until 1.0
                if (volume >= 1.0) {
                    volume = 1.0;
                    clearInterval(fadeInterval);
                }
                audioPlayer.volume = volume;
            }, fadeInOutDuration / 20); // 20 intervals during the fade duration
        }
        function fadeAudioToPause() {
            let volume = 1.0;
            const fadeInterval = setInterval(function() {
                volume -= 0.05; // decrease by 0.05 until 0
                if (volume <= 0.0) {
                    volume = 0.0;
                    audioPlayer.pause();
                    clearInterval(fadeInterval);
                }
                audioPlayer.volume = volume;
            }, fadeInOutDuration / 20); // 20 intervals during the fade duration
        }
        // get "exception" key from an object;
        // if no object -> use empty object by default
        const enableAllButtons = ({ exception: exception } = {})=>{
            this.allButtons.forEach((button)=>{
                // if (exception && button.id === exception) return
                button.disabled = false;
            });
        };
        const disableAllButtons = ()=>{
            this.allButtons.forEach((button)=>{
                button.disabled = true;
            });
        };
        // player audio controls
        function togglePlayPause() {
            if (audioPlayer.paused || audioPlayer.ended) {
                playButton.classList.add("playing");
                fadeAudioToPlaying();
            } else {
                playButton.classList.remove("playing");
                fadeAudioToPause();
            }
            temporaryDisableAllButtons();
        }
        const temporaryDisableButton = (button)=>{
            button.setAttribute("disabled", "");
            setTimeout(()=>{
                button.removeAttribute("disabled");
            }, fadeInOutDuration);
        };
        const temporaryDisableAllButtons = ()=>{
            this.allButtons.forEach((button)=>{
                temporaryDisableButton(button);
            });
        };
        // const disableButton = (button) => button.setAttribute('disabled', '')
        // const enableButton = (button) => button.removeAttribute('disabled')
        //
        //
        const fadeOutPlayingState = ()=>{
            playButton.classList.remove("playing");
            fadeAudioToPause();
        };
        // if playlist button is clicked
        // change playlist and load first two tracks of it
        document.querySelector("#playlists").addEventListener("click", async (event)=>{
            // playlist button is clicked
            if (event.target.closest(".playlist")) {
                const playlistButton = event.target.closest(".playlist");
                // const playlistName = playlistButton.dataset.playlistName
                if (playlistButton.classList.contains("playlist--selected")) {
                    console.log("playlist already selected");
                    return;
                }
                $d3b96eb1e0e45c37$var$resetRepeatId();
                document.querySelector(".playlist--selected").classList.remove("playlist--selected");
                playlistButton.classList.add("playlist--selected");
                const newPlaylistName = playlistButton.dataset.playlistName;
                const newPlaylist = this.availablePlaylists.find((playlist)=>playlist.playlistName === newPlaylistName);
                fadeOutPlayingState();
                // disable all buttons until first track is ready
                disableAllButtons();
                // end current track, so statistics and 'like'/'dislike' could be sent
                $d3b96eb1e0e45c37$var$skipped = true;
                $d3b96eb1e0e45c37$var$playlistShouldChange = true;
                this.audioPlayer.dispatchEvent(new Event("ended"));
                await this.setPlaylistData({
                    newPlaylist: newPlaylist
                });
                // cancel loadtrack repeating if playlist has changed
                // resetRepeatId()
                // new playlist is set
                // make sure data is updated
                try {
                    await this.initializeFirstTwoTracksOfAPlaylist({
                        firstTrackLoaded: ()=>{
                            enableAllButtons({
                                exception: "skip-button"
                            });
                        }
                    });
                } catch (error) {
                    console.error(`playlist error: can't load first two tracks of a new playlist`);
                }
            }
        });
        const form = document.querySelector("#like-dislike-form");
        form.addEventListener("submit", (e)=>{
            e.preventDefault();
            const submitter = e.submitter;
            const like = submitter.id === "like-button";
            const dislike = submitter.id === "dislike-button";
            if (like) {
                if ($d3b96eb1e0e45c37$var$likeDislikeStatus.scheduled && $d3b96eb1e0e45c37$var$likeDislikeStatus.newStatus === "Like") {
                    $d3b96eb1e0e45c37$var$resetLikeDislikeScheduledValues();
                    return;
                }
                if ($d3b96eb1e0e45c37$var$likeDislikeStatus.scheduled && $d3b96eb1e0e45c37$var$likeDislikeStatus.newStatus === "Dislike") $d3b96eb1e0e45c37$var$resetLikeDislikeScheduledValues();
                $d3b96eb1e0e45c37$var$scheduleLikeDislike({
                    newStatus: "Like"
                });
            }
            if (dislike) {
                if ($d3b96eb1e0e45c37$var$likeDislikeStatus.scheduled && $d3b96eb1e0e45c37$var$likeDislikeStatus.newStatus === "Dislike") {
                    $d3b96eb1e0e45c37$var$resetLikeDislikeScheduledValues();
                    return;
                }
                if ($d3b96eb1e0e45c37$var$likeDislikeStatus.scheduled && $d3b96eb1e0e45c37$var$likeDislikeStatus.newStatus === "Like") $d3b96eb1e0e45c37$var$resetLikeDislikeScheduledValues();
                $d3b96eb1e0e45c37$var$scheduleLikeDislike({
                    newStatus: "Dislike"
                });
            }
        });
        // finally, enable all buttons
        enableAllButtons({
            exception: "skip-button"
        });
    }
    loadTrack({ tracks: tracks, trackIndex: trackIndex, returnOnlyBlob: returnOnlyBlob }) {
        // This function calls function which sets correct interval. It changes index to 0 if interval changes,
        // or we should start from the beginning.
        // Then it loads new track to blob.
        // use this to handle (cancel) retries
        const localRepeatId = new Date().getTime();
        $d3b96eb1e0e45c37$var$globalRepeatId = localRepeatId;
        console.log("ppp", tracks[trackIndex]);
        return $d3b96eb1e0e45c37$var$fetchWithRetry(tracks[trackIndex], {
            retryDelay: 1000,
            // retryDelay: 0,
            retryOn: function(attempt, error, response) {
                // alert(1)
                // console.log('ro', new Date().getTime())
                console.log("get second", new Date().getSeconds());
                if (response && response.status === 404) {
                    // похоже что у этого трэка битая ссылка
                    //
                    console.warn("fetch error, 404, track not found");
                    return false;
                }
                // console.log('lri', localRepeatId)
                // console.log('gri', globalRepeatId)
                if (localRepeatId !== $d3b96eb1e0e45c37$var$globalRepeatId) {
                    console.log("reset counter");
                    console.log("cancel this track loading");
                    return false;
                }
                if (error !== null || response.status >= 500) {
                    // что-то не то, -- делаем повтор запроса
                    console.log("ошибка при получении песни");
                    console.log("делаем повтор запроса...");
                    // console.log('error111', error)
                    console.log("повтор номер", attempt + 1);
                    return true;
                }
            }
        }).then(async (response)=>{
            if (!response.ok) throw new Error("Network response was not ok");
            // return response.blob();
            // specify blob type to hopefully avoid safari bug
            const arrayBuffer = await response.arrayBuffer();
            const blob = new Blob([
                arrayBuffer
            ], {
                type: "audio/mpeg"
            });
            return blob;
        }).then((blob)=>{
            if (returnOnlyBlob) return blob;
            if (blob.size > 0) {
                console.log("Successfully fetched and have content in blob.");
                return URL.createObjectURL(blob);
            } else console.warn("Fetch was successful but blob is empty.");
        });
    }
    getCurrentInterval(data) {
        // This function aims to find the current time interval (based on the hour of the day) from a given list of intervals,
        // and return the associated URLs and the index of the interval within the provided list.
        const currentHour = new Date().getHours(); // Get the current hour (0 - 23)
        const currentInterval = data.find((interval, i)=>{
            const [start, end] = interval.time.split("-").map(Number); // Convert "12-15" to [12, 15]
            // it's a 24/7 playlist
            // so it will be the same forever. without any additional assertion
            if (start === end) return true;
            // Adjust for times wrapping midnight, e.g., "23-2"
            if (start > end) return currentHour >= start || currentHour < end;
            else return currentHour >= start && currentHour < end;
        });
        // console.log('currentIII', currentInterval)
        if (currentInterval) {
            const index = data.findIndex((interval)=>interval.time === currentInterval.time);
            currentInterval.index = index;
        }
        return currentInterval;
    // {time:'11-12', signedURLs: [...]}
    // {time:'11-12', signedURLs: [...], index: 0}
    // {time:'12-21', signedURLs: [...], index: 9}
    }
    getCurrentIntervalRelatedData(currentInterval) {
        if (currentInterval) // console.log('currentII', currentInterval)
        return {
            // urls: currentInterval.signedURLs,
            urls: currentInterval.encodedURLs,
            index: currentInterval.index
        };
        return {
            urls: [],
            index: -1
        }; // Default return if no matching interval is found
    }
    // returns array of objects
    // for example: [{ time: "8-12", signedURLs: ["1.mp3", "2.mp3", "3.mp3"] }, {...} ]
    getCurrentDaySongsInPlaylist(playlistArray) {
        // THIS function works (getting as an argument) the whole playlist with all the days intervals
        // IT RETURNS the array with intervals for a particular day. The result of interval sets is time-sorted
        // Get the current day
        const currentDate = new Date();
        const currentDay = currentDate.toLocaleString("en-US", {
            weekday: "long"
        });
        // Define an object to store intervals and their respective songs
        const songIntervals = {};
        //console.log('playlistObj is ', playlistObj)
        playlistArray.forEach((song)=>{
            // Check if the song has an interval for the current day
            const interval = song.fields[currentDay];
            if (interval) {
                // Check if we already have this interval in the songIntervals object
                if (!songIntervals[interval]) songIntervals[interval] = [];
                // Add the song's signedUrl to the interval array
                // songIntervals[interval].push(song.signedUrl);
                songIntervals[interval].push(song.fields["Full link"]);
            }
        });
        // Convert songIntervals object to the desired array format
        const result = [];
        for(const interval in songIntervals)result.push({
            time: interval,
            // signedURLs: randomize(songIntervals[interval]), // Assuming shuffle is a function you've defined elsewhere
            encodedURLs: (0, $923d0d426c4966e8$export$a477072d5b4aa0b)(songIntervals[interval]) // Assuming shuffle is a function you've defined elsewhere
        });
        // Now, let's sort the intervals
        result.sort((a, b)=>{
            const [startA, endA] = a.time.split("-").map(Number);
            const [startB, endB] = b.time.split("-").map(Number);
            // Handle cases where interval wraps around midnight
            if (startA > endA && (startB <= endB || startA < startB)) return 1;
            if (startB > endB && (startA <= endA || startB < startA)) return -1;
            return startA - startB;
        });
        // We get here array of objects which look like this, they are sorted from early to late:
        // { time: "8-12", signedURLs: ["1.mp3", "2.mp3", "3.mp3"] },
        // { time: "12-16", signedURLs: ["4.mp3", "5.mp3", "6.mp3"] },
        // { time: "16-20", signedURLs: ["7.mp3", "8.mp3", "9.mp3"] }
        // console.log('resultlll', result)
        return result;
    }
    constructor(){
        (0, $1d4928dd02c4c5ce$export$1e71eb4bef00f6b0)(this, "currentTrackIndex", 0);
        (0, $1d4928dd02c4c5ce$export$1e71eb4bef00f6b0)(this, "nextTrackIndex", 1);
        // track urls are used as a lightweight version of id
        (0, $1d4928dd02c4c5ce$export$1e71eb4bef00f6b0)(this, "currentTrackUrl", null);
        (0, $1d4928dd02c4c5ce$export$1e71eb4bef00f6b0)(this, "nextTrackUrl", null);
        (0, $1d4928dd02c4c5ce$export$1e71eb4bef00f6b0)(this, "tracks", null);
        (0, $1d4928dd02c4c5ce$export$1e71eb4bef00f6b0)(this, "currentIntervalData", null);
        (0, $1d4928dd02c4c5ce$export$1e71eb4bef00f6b0)(this, "nextBlobURL", null);
        (0, $1d4928dd02c4c5ce$export$1e71eb4bef00f6b0)(this, "currentBlobURL", null);
        (0, $1d4928dd02c4c5ce$export$1e71eb4bef00f6b0)(this, "currentIntervalIndex", -1);
        (0, $1d4928dd02c4c5ce$export$1e71eb4bef00f6b0)(this, "currentPlaylistInitialData", null);
        (0, $1d4928dd02c4c5ce$export$1e71eb4bef00f6b0)(this, "currentDayPlaylist", null);
        (0, $1d4928dd02c4c5ce$export$1e71eb4bef00f6b0)(this, "currentPlaylistTableId", null);
        (0, $1d4928dd02c4c5ce$export$1e71eb4bef00f6b0)(this, "currentPlaylistTableName", null);
        (0, $1d4928dd02c4c5ce$export$1e71eb4bef00f6b0)(this, "allButtons", document.querySelectorAll("button"));
        (0, $1d4928dd02c4c5ce$export$1e71eb4bef00f6b0)(this, "audioPlayer", document.getElementById("audioPlayer"));
        (0, $1d4928dd02c4c5ce$export$1e71eb4bef00f6b0)(this, "baseId", null);
        (0, $1d4928dd02c4c5ce$export$1e71eb4bef00f6b0)(this, "availablePlaylists", null);
        if (!this.audioPlayer) throw Error("Error: audioPlayer html element must be set for player to initialize");
    }
}


// set a handler to logout buttons
// (do it here, so buttons will be active almost instantly, without waiting for a first track to load)
const $6465bb625eab389c$var$logOutButtons = document.querySelectorAll(".js-logout-buttons-wrapper button");
$6465bb625eab389c$var$logOutButtons.forEach((button)=>{
    button.onclick = ()=>{
        localStorage.removeItem("login");
        localStorage.removeItem("password");
        // this will refresh a page
        window.location = window.location;
    };
});
const $6465bb625eab389c$var$getBaseId = async ()=>{
    const baseId = await new Promise((resolve)=>{
        (0, $72239ddbc700e165$export$da4fc2bf424da4ca)(resolve);
    });
    return baseId;
};
// const records = [
//   {
//     "id": "tbl886QoG6g0tC9tV",
//     "createdTime": "2023-04-27T10:22:27.000Z",
//     "fields": {
//       "Name": "Indie playlist",
//       "Status": "Active",
//       "Notes": "Главный плейлист. Инди настроечка, лайтовый, ласковый, без бороды и шашлывков. йо\nРасписание: — здесь должно быть описано, как играет плейлист в течении недели —"
//     }
//   },
//   {
//     "id": "tblyqMDwKvBNSJPOY",
//     "createdTime": "2023-06-20T18:04:28.000Z",
//     "fields": {
//       "Name": "test playlist #2",
//       "Status": "Active",
//       "Notes": "test playlist description"
//     }
//   },
// ];
(async ()=>{
    const baseId = await $6465bb625eab389c$var$getBaseId();
    const queryParams = {
        baseId: baseId,
        tableId: "Info"
    };
    const searchParams = new URLSearchParams(queryParams);
    const urlToFetchRecords = `${(0, $2844b45deb73c289$export$c23c9806c2c0bf65)}?${searchParams}`;
    const response = await fetch(urlToFetchRecords);
    const playlistsInfo = await response.json();
    console.log("playlistsInfo", playlistsInfo);
    const playlists = document.querySelector("#playlists");
    const renderPlaylistsMarkup = ()=>{
        playlists.innerHTML = "";
        playlistsInfo.forEach((playlist, i)=>{
            const playlistName = playlist.fields["Name"];
            const playlistDescription = playlist.fields["Notes"];
            // const { playlistName, playlistDescription } = playlist
            const selected = i === 0;
            if (selected) document.querySelector("#current-playlist").innerHTML = playlistName;
            const html = `
        <button disabled class="playlist ${selected ? "playlist--selected" : ""}" data-playlist-name="${playlistName}">
          <span class="playlist__name">
            <span class="note-sign">🎶</span> ${playlistName}
          </span>
          <span class="playlist__description">
            ${playlistDescription}
          </span>
        </button>
      `;
            playlists.innerHTML += html;
        });
    };
    renderPlaylistsMarkup();
    console.log("ap", playlistsInfo);
    const availablePlaylists = playlistsInfo.map((playlist)=>{
        const playlistName = playlist.fields["Name"];
        const tableId = playlist.tableId;
        return {
            playlistName: playlistName,
            tableId: tableId
        };
    });
    // handlePlayer(availablePlaylists, baseId)
    const player = new (0, $d3b96eb1e0e45c37$export$2616165974278734)();
    await player.initializePlayer(availablePlaylists, baseId);
})();

})();
//# sourceMappingURL=index.63c9a6e4.js.map
